import { List, ListSubheader } from "@mui/material";
import * as React from "react";
import { useContext, useEffect, useState } from "react";

import { Collection as GqlCollection } from "../../../../generated/gql/graphql";
import useCollections from "../../../../hooks/query/collection/use-collections";
import useSharedCollections from "../../../../hooks/query/collection/use-shared-collections";
import useText from "../../../../hooks/use-text";
import { UserContext } from "../../../../providers/user-provider";
import { parseType } from "../../../../utils/graphql";
import { LocalizedStrings, SupportedLanguages } from "../../../../utils/lang";

import LeftNavigationSubheader from "./left-navigation-subheader";

export default function LeftNavigation(): React.ReactElement {
  const { me } = useContext(UserContext);

  const { strings } = useText(local);
  const [yourCollections, setYourCollections] = useState<GqlCollection[]>([]);
  const { data: yourCollectionsResult } = useCollections();

  const [sharedCollections, setSharedCollections] = useState<GqlCollection[]>(
    []
  );
  const { data: sharedCollectionsResult } = useSharedCollections(
    me?.id || "-1"
  );

  useEffect(() => {
    if (!yourCollectionsResult) {
      return;
    }

    setYourCollections(
      parseType<GqlCollection[]>("collections", yourCollectionsResult)
    );
  }, [yourCollectionsResult]);

  useEffect(() => {
    if (!sharedCollectionsResult) {
      return;
    }

    setSharedCollections(
      parseType<GqlCollection[]>("sharedCollections", sharedCollectionsResult)
    );
  }, [sharedCollectionsResult]);

  // const handleCollectionChange = (id: string | number): void => {
  //     collectionId === id ? setCollectionId(undefined) : setCollectionId(id);
  // };

  // const handleDeleteCollection = (collection: GqlCollection): void => {
  //     if (confirm("Are you sure?")) {
  //         (async () => {
  //             await deleteCollectionById(collection.id);
  //
  //             enqueueSnackbar(`Collection ${collection.name} was deleted.`, {
  //                 variant: "success",
  //             });
  //
  //             setFilterCollections(() =>
  //                 filterCollections?.filter((item) => item.id !== collection.id)
  //             );
  //             setCollections(() =>
  //                 collections?.filter((item) => item.id !== collection.id)
  //             );
  //             setCollectionId(undefined);
  //         })();
  //     }
  // };

  return (
    <List
      sx={{ bgcolor: "background.paper" }}
      className="shadow max-w-[320px] width-full rounded-[15px] overflow-hidden pt-[8px] mb-[25px] ml-[45px]"
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListSubheader component="div" id="nested-list-subheader">
          {strings.title}
        </ListSubheader>
      }
    >
      {yourCollections && (
        <LeftNavigationSubheader
          name={strings.subheader.yourCollections.replace(
            "{{count}}",
            yourCollections?.length.toString() || "0"
          )}
          //activeCollectionId={}
          collections={yourCollections}
        />
      )}
      {sharedCollections && (
        <LeftNavigationSubheader
          name={strings.subheader.sharedCollections.replace(
            "{{count}}",
            sharedCollections?.length.toString() || "0"
          )}
          collections={sharedCollections}
        />
      )}
    </List>
  );
}

type LocalSchema = {
  title: string;
  subheader: {
    yourCollections: string;
    sharedCollections: string;
  };
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    title: "Collections",
    subheader: {
      yourCollections: "Your Collections ({{count}})",
      sharedCollections: "Collections shared with you ({{count}})",
    },
  },
};
